import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import logo from "@/assets/logo-new.png";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-primary/5 via-background to-accent/5">
      <div className="text-center space-y-6 px-4">
        <img 
          src={logo} 
          alt="Naturkraft Logo" 
          className="mx-auto h-20 w-auto mb-8 transition-all duration-300 hover:scale-110 hover:drop-shadow-[0_0_20px_rgba(34,197,94,0.5)]"
        />
        <h1 className="text-8xl font-bold text-primary">404</h1>
        <p className="text-2xl text-foreground/80">Oops! Seite nicht gefunden</p>
        <Button 
          asChild
          size="lg"
          className="mt-8"
        >
          <a href="/">Zurück zur Startseite</a>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
